import request from '../request';

export type DynamicObjectExportTaskStatus =
  | 'PENDING'
  | 'IN_PROGRESS'
  | 'DONE'
  | 'ERROR'
  | string;

export interface DynamicObjectExportTask {
  id: number;
  name: string;
  error: string | null;
  status: DynamicObjectExportTaskStatus;
  output: unknown;
  createdAt: string;
}

export interface DynamicObjectExportTaskCreateFields {
  name?: string;
  cards?: string[];
  properties: string[];
  boards?: string[];
}

export interface DynamicObjectExportTaskCreateParams {
  fields: DynamicObjectExportTaskCreateFields;
}

export type DynamicObjectExportTaskCreateResponse = DynamicObjectExportTask;

export interface DynamicObjectExportTaskListFilter {
  limit?: number;
  offset?: number;
}

export interface DynamicObjectExportTaskGetListParams {
  filter?: DynamicObjectExportTaskListFilter;
}

export interface DynamicObjectExportTaskGetListResponse {
  list: DynamicObjectExportTask[];
  total: number;
}

export const dynamicObjectExportTaskCreate = request<
  DynamicObjectExportTaskCreateResponse,
  DynamicObjectExportTaskCreateParams
>({
  method: 'dynamicObjectExportTask.create',
});

export const dynamicObjectExportTaskGetList = request<
  DynamicObjectExportTaskGetListResponse,
  DynamicObjectExportTaskGetListParams
>({
  method: 'dynamicObjectExportTask.getList',
});

